import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState, type GenericMap } from "@client/types";
import { loadDetail } from "../actions";
import { localStateSelector } from "../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

type Props = RootContainerProps & {
  formId: string;
};
const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();

  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      apiInfo: apiInfoSelector(state, props),
      status: localState.status
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  enter: (data: GenericMap<any>) => dispatch(loadDetail(props, props.formId, data))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
